/* eslint-disable */
import React, { createContext, useState, useEffect, useContext } from 'react';
import configFunction from './config.functions';
import { useHistory } from 'react-router-dom';
import { ConfigContextUtils } from './contextUtils.context';

export const ConfigContext = createContext();

const GeneralProvider = (props) => {

    const { setPreloader } = useContext(ConfigContextUtils);
    const history = useHistory();
    const [config, setConfiguracion] = useState(null);
    const [load, setLoad] = useState(false);
    const [rol, setRol] = useState(null);

    const updateConfigExtra = (data) => {
        setConfiguracion({
          ...config,
          operaciones: data,
        });
    }

    const obtenerConfiguracion = () => {
      configFunction.config().then((response) => {
        if (response.status === 401) {
           localStorage.clear();
           history.replace('/login');
        } else {
          setRol(response.tipo_user);
          setConfiguracion({
            ...response.data,
            graficos: response.graficos,
            operaciones: response.operaciones,
            tipo_salidas: response.tipo_salidas,
          });
          setLoad(true);
          setPreloader(false);
        }
      }, () => {
        localStorage.clear();
        history.replace('/login');
      })
    }

    useEffect(() => {
      obtenerConfiguracion();
    }, []);

    return (
      <ConfigContext.Provider
        value={{
          config,
          setConfiguracion,
          load,
          rol,
          obtenerConfiguracion,
          updateConfigExtra,
        }}
      >
        {props.children}
      </ConfigContext.Provider>
    )

}

export default GeneralProvider;